import { CommonPipesModule } from 'app/shared/pipes/common-pipes.module';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { JustgageModule } from 'angular2-justgage';
import { MultiSelectModule, OverlayPanelModule } from 'primeng/primeng';
import { ListboxModule } from 'primeng/primeng';
import {
    EditorModule, TabViewModule,
    CalendarModule, DataTableModule, MenubarModule, ConfirmDialogModule, ConfirmationService,
    TooltipModule
} from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';
import { AutoCompleteModule } from 'primeng/primeng';
import { DomSanitizer } from '@angular/platform-browser';

import { EntityTransactionProfileComponent } from 'app/entities/transaction-profile/entity-transaction-profile.component';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';
import {
    EntityTransactionProfileClientComponent
} from 'app/entities/transaction-profile/entitytransactionprofileclient/entity-transaction-profile-client.component';
import {
    TransactionProfileDescComponent
} from 'app/entities/transaction-profile/transactionprofiledesc/transaction-profile-desc.component';
import { AgreementComponent } from 'app/entities/transaction-profile/agreements/agreement.component';
import { SaveAgreementComponent } from 'app/entities/transaction-profile/agreements/saveagreement/save-agreement.component';
import { DocumentComponent } from 'app/entities/transaction-profile/documents/document.component';
import { RightComponent } from 'app/entities/transaction-profile/rights/right.component';
import { ObligationComponent } from 'app/entities/transaction-profile/obligations/obligation.component';
import { RiskComponent } from 'app/entities/transaction-profile/risks/risk.component';

import { AddDocumentComponent } from 'app/entities/transaction-profile/documents/adddocument/add-document.component';
import { AddRightComponent } from 'app/entities/transaction-profile/rights/addright/add-right.component';
import { AddObligationComponent } from 'app/entities/transaction-profile/obligations/addobligation/add-obligation.component';
import { AddRiskComponent } from 'app/entities/transaction-profile/risks/addrisk/add-risk.component';
import { UpdateRiskComponent } from 'app/entities/transaction-profile/risks/updaterisk/update-risk.component';
import { EntitySurveysModule } from 'app/entities/surveys/entity-surveys.module';
import { EntityFinanceModule } from 'app/entities/finance/entity-finance.module';
import { TransactionProfileDescService } from 'app/entities/transaction-profile/transactionprofiledesc/transaction-profile-desc.service';
import { TransactionRuleComponent } from './transaction-rule/transaction-rule.component';
import { AddTransactionRuleComponent } from './transaction-rule/add-transaction-rule/add-transaction-rule.component';
import { MoveTransactionRuleDialogComponent } from './transaction-rule/move-transaction-rule-dialog.component';
import { TestRuleTransactionsDialogComponent } from './transaction-rule/test-rule-transactions-dialog.component';
import { AgreementDocumentsDialogComponent } from './agreements/agreement-documents-dialog.component';

@Pipe({ name: 'filterTransactionRule' })
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) {
            return [];
        }
        if (!searchText) {
            return items;
        }
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            return it.name.toLowerCase().includes(searchText);
        });
    }
}

@NgModule({
    declarations: [
        EntityTransactionProfileComponent,
        EntityTransactionProfileClientComponent,
        TransactionProfileDescComponent,
        AgreementComponent,
        SaveAgreementComponent,
        DocumentComponent,
        RightComponent,
        ObligationComponent,
        RiskComponent,
        AddDocumentComponent,
        AddRightComponent,
        AddObligationComponent,
        AddRiskComponent,
        UpdateRiskComponent,
        FilterPipe,
        TransactionRuleComponent,
        AddTransactionRuleComponent,
        MoveTransactionRuleDialogComponent,
        TestRuleTransactionsDialogComponent,
        AgreementDocumentsDialogComponent
    ],
    imports: [
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBw6zrtGzSpNfaPR1BOfMnqUnH6cONDyLk',
            libraries: ['places']
        }),
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        SharedModule,
        CalendarModule,
        TabViewModule,
        JustgageModule,
        MenubarModule,
        ConfirmDialogModule,
        EditorModule,
        AutoCompleteModule,
        TooltipModule,
        MultiSelectModule,
        ListboxModule,
        EntitySurveysModule,
        EntityFinanceModule,
        CommonPipesModule,
        OverlayPanelModule
    ],
    providers: [
        EntityTransactionProfileService,
        TransactionProfileDescService
    ],
    entryComponents: [
        SaveAgreementComponent,
        AddDocumentComponent,
        AddRightComponent,
        AddObligationComponent,
        AddRiskComponent,
        UpdateRiskComponent,
        AddTransactionRuleComponent,
        MoveTransactionRuleDialogComponent,
        AgreementDocumentsDialogComponent,
        TestRuleTransactionsDialogComponent
    ],
    exports: [
        EntityTransactionProfileComponent,
    ]
})

/**
 * Main module for the entity transaction profile tab management.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
*/
export class EntityTransactionProfileModule { }



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/entity-transaction-profile.module.ts